import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, merge, Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';

import { TabType } from 'fc-ui-components';

import { MainNavigationService } from 'app/components/main-navigation/main-navigation.service';
import { DownloadsService } from 'app/content/services/downloads.service';

@Component({
    selector: 'fc-main-content-drawer',
    templateUrl: './main-content-drawer.component.html',
    styleUrls: ['./main-content-drawer.component.less'],
    standalone: false
})
export class MainContentDrawerComponent implements OnInit {
    selectedTab: Observable<ContentDrawerTabs>;

    contentDrawerTabs = ContentDrawerTabs;
    tabTypeEnum = TabType;

    private tabChangeSubject = new BehaviorSubject<ContentDrawerTabs>(ContentDrawerTabs.MultiDownload);

    constructor(
        private downloadService: DownloadsService,
        private mainNavigationService: MainNavigationService
    ) {}

    ngOnInit() {
        const isDownloadListOpen$ = this.mainNavigationService.isDownloadListOpen;
        const downloadListUpdated$ = this.downloadService.getDownloadListUpdated().pipe(
            withLatestFrom(isDownloadListOpen$),
            map(([_, downloadListOpen]) => {
                const count = this.downloadService.getCount();
                return count === 0 && !downloadListOpen
                    ? ContentDrawerTabs.MultiDownload
                    : ContentDrawerTabs.DownloadList;
            })
        );

        const tabChange$ = this.tabChangeSubject.asObservable();

        this.selectedTab = merge(downloadListUpdated$, tabChange$);
    }

    onTabChange(tab: string) {
        this.tabChangeSubject.next(tab as ContentDrawerTabs);
    }
}

enum ContentDrawerTabs {
    DownloadList = 'downloadList',
    MultiDownload = 'multiDownlaod'
}
